import { useMutation, useQuery } from "react-query";
import QUERY_KEYS from "../queryKeys";
import commonConfig from "../config";
import {
  addEarlyAccessUser,
  getIP,
  getPrimarySportDetails,
  postEarlyAccessResendOtp,
  postEarlyAccessVerifyOtp,
} from "./queryFunctions";

export const usePrimarySportDetails = (config = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.PRIMARY_SPORT_DETAILS],
    queryFn: () => getPrimarySportDetails(),
    ...commonConfig,
    ...config,
  });

export const useAddEarlyAccessUserMutation = (config = {}) =>
  useMutation({
    mutationFn: (payload) => addEarlyAccessUser(payload),
    mutationKey: [QUERY_KEYS.EARLY_ACCESS_ADD_USER],
    ...commonConfig,
    ...config,
  });

export const usePostEarlyAccessVerifyOtpMutation = (config = {}) =>
  useMutation({
    mutationFn: (payload) => postEarlyAccessVerifyOtp(payload),
    mutationKey: [QUERY_KEYS.EARLY_ACCESS_VERIFY_OTP],
    ...commonConfig,
    ...config,
  });

export const usePostEarlyAccessResendOtpMutation = (config = {}) =>
  useMutation({
    mutationFn: (payload) => postEarlyAccessResendOtp(payload),
    mutationKey: [QUERY_KEYS.EARLY_ACCESS_RESEND_OTP],
    ...commonConfig,
    ...config,
  });

export const useIP = (config = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.GET_IP],
    queryFn: () => getIP(),
    ...commonConfig,
    ...config,
  });
